import { PromocodeProviderEnum } from "../"

export class PromocodeConfigField {
    name: string
    type: "text" | "email" | "phone" | "number" | "date"
    label_content_name: string
    valueValidationRegex: string
    error_content_name: string
    isMandatory?: boolean
    constructor(
        name: string,
        type: "text" | "email" | "phone" | "number" | "date",
        label_content_name: string,
        valueValidationRegex: string,
        error_content_name: string,
        isMandatory?: boolean
    ) {
        this.name = name
        this.type = type
        this.label_content_name = label_content_name
        this.valueValidationRegex = valueValidationRegex
        this.error_content_name = error_content_name
        this.isMandatory = isMandatory
    }
}

export class PromocodeConfig {
    fields: PromocodeConfigField[]
    provider: PromocodeProviderEnum
    title_content_name: string
    constructor(
        fields: PromocodeConfigField[],
        provider: PromocodeProviderEnum,
        title_content_name: string,
    ) {
        this.fields = fields
        this.provider = provider
        this.title_content_name = title_content_name
    }
}